import React, { forwardRef, useEffect, useState } from "react";
import './ApresentationSection.css';
const ApresentationSection = forwardRef(({ scrollToNextSection }, ref) =>  {

  const [opacity, setOpacity] = useState(1);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      setIsScrolling(true);

      // Limpa o temporizador anterior se houver
      clearTimeout(timeoutId);

      // Configura um temporizador para iniciar a transição de opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(0); // Começa a desaparecer gradativamente
      }, 10); // Inicia a transição de opacidade após 100ms

      // Configura um temporizador para restaurar a opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(1); // Restaura a opacidade
        setIsScrolling(false);
      }, 200); // Tempo para restaurar a opacidade após 1 segundo de inatividade
    };

    // Adiciona o ouvinte de evento de rolagem
    window.addEventListener('scroll', handleScroll);

    // Remove o ouvinte de evento quando o componente é desmontado
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const parallax = document.getElementById('banner');
      const scrolled = window.scrollY;
      parallax.style.transform = `translateY(${scrolled * 0.2}px)`; // Ajuste a velocidade do efeito
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  

  return (
        <section id={"apresentation-section"} className="apresentation-section" ref={ref}>
            <div className="content">
                <div className="row"></div>
                <h1><span>estúdio</span>ZUPA</h1>
                <p id="text">Um espaço completo e versátil para sua produção fotográfica, em um ambiente amplo e
contemporâneo, bem localizado e próximo a mercados, lojas de utilidades, restaurantes,
padarias e farmácias.</p>
                <div className="address">
                  <label>LAPA</label>
                  <span>•</span>
                  <label>ZONA OESTE</label>
                  <span>•</span>
                  <label>SÃO PAULO</label>
                </div>
                <img id="banner-mobile" src="/assets/img/Camera.png"/>
                <a target={"_blank"} href={'https://wa.me/5511950742962'} id="fale"><i className="fa fa-phone"></i><span>| FALE COM A GENTE</span></a>
            </div>
            <img id="banner" src="/assets/img/Camera.png"/>
            <div className="transaction">
            <button onClick={scrollToNextSection} style={{
          opacity,
          transition: 'opacity .1s ease' // Animação de transição de opacidade
        }}><span>SCROLL DOWN</span><img src="/assets/icons/angle-down.png"/></button>
            </div>
        </section>
    
    
  );
});

export default ApresentationSection;
